/**
 * Configuración centralizada de WhataLab
 * Todas las URLs externas y constantes del proyecto
 */

// Modo mantenimiento — true: la landing (/) muestra la pantalla "Estamos en mantenimiento"
// Poner en false para restaurar la landing completa (no se borra nada).
export const MAINTENANCE_MODE = false;

// Banner de novedades (ticker superior) — true: se muestra el AnnouncementBanner.
// Poner en false para ocultarlo sin borrar el componente.
export const SHOW_ANNOUNCEMENT_BANNER = false;

// Convocatoria Junta General Extraordinaria — true: se muestra el AssemblyNoticeModal
// (una vez por pestaña, vía sessionStorage). Poner en false para ocultarlo sin borrar nada.
export const SHOW_ASSEMBLY_NOTICE = true;

// URLs externas
export const EXTERNAL_LINKS = {
  // Plataformas WhataLab
  TOOLS_PLATFORM: 'https://tools.whatalab.io/',
  TOOLS_BUY: 'https://tools.whatalab.io/buy',
  TOOLS_ORDERBOOK: 'https://tools.whatalab.io/orderbook',
  PANEL: 'https://panel.whatalab.io/',
  WHATANEWS: '/whatanews', // TODO: Añadir URL de WhataNews cuando esté disponible
  
  // Redes sociales
  DISCORD: 'https://discord.gg/HxbEqFRFjW',
  TWITTER: 'https://x.com/WhataLab_',
  SPOTIFY: 'https://open.spotify.com/show/3uYiIIzsNWXQbFQLTJTRBq',
  
  // Ecosistema Hedera
  HEDERA: 'https://hedera.com/',
};

// Datos de colecciones NFT
export const NFT_COLLECTIONS = {
  WHATAKIT: {
    name: 'WhataKit',
    floorPrice: 150,
    symbol: 'ℏ',
  },
  WATT: {
    name: 'WATT',
    floorPrice: 480,
    symbol: 'ℏ',
  },
  EARLY_PACK: {
    name: 'Early Pack',
    floorPrice: 1500,
    symbol: 'ℏ',
  },
};

// Estadísticas del Hero (pueden actualizarse desde API en el futuro)
export const HERO_STATS = {
  EARLY_PACK_FP: '1500ℏ',
  WATT_FP: '480ℏ',
  WHATAKIT_FP: '150ℏ',
  RELEASED_SUPPLY: '412',
  TOTAL_HOLDERS: '129',
};

// Navegación principal
export const NAV_ITEMS = [
  { name: 'Home', href: '#home', icon: 'Home' },
  { name: 'About Us', href: '#about', icon: 'Info' },
  { name: 'Why Hedera', href: '#why-hedera', icon: 'Hexagon' },
  { name: 'Tools', href: '#tools', icon: 'Wrench' },
  { name: 'Ecosystem', href: '#ecosystem', icon: 'Layers' },
  { name: 'FAQs', href: '#faqs', icon: 'HelpCircle' },
];

// Categorías de herramientas
export const TOOL_CATEGORIES = [
  'All',
  'NFT Trading',
  'HTS Trading',
  'Analytics',
  'Creators',
  'Projects Fan',
  'Utility Token',
];

// Fecha de lanzamiento WhataNews
export const WHATANEWS_LAUNCH_DATE = new Date('January 12, 2026 00:00:00').getTime();
